import { useEffect, useState } from 'react';
import TranslationManager from '../../../assets/locale/translationsManager';

function useTranslationRefresh() {
  const [, refresh] = useState<boolean>(false);
  useEffect(() => {
    TranslationManager.setChangeListener(refresh);
    return () => {
      TranslationManager.removeChangeListener();
    };
  }, []);
}

export default useTranslationRefresh;
